import { render } from "./SurveyReporting.vue?vue&type=template&id=0c2faad2&scoped=true"
import script from "./SurveyReporting.vue?vue&type=script&lang=js"
export * from "./SurveyReporting.vue?vue&type=script&lang=js"

import "./SurveyReporting.vue?vue&type=style&index=0&id=0c2faad2&scoped=true&lang=css"

import exportComponent from "/home/adssilicondigital/ads.silicon.digital/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c2faad2"]])

export default __exports__